export const submissionTypes = [
  { label: "Solicitud directa de la implementadora", value: "DIRECT" },
  { label: "Invitación de FICOSEC", value: "INVITATION" },
  { label: "Convocatoria", value: "CALL" },
  { label: "Proyectos menores", value: "MINOR" }
]
